<template>
  <div>
    <van-nav-bar title="服务" right-text="切换企业" @click-right="showClientList = true" />
    <my-company />
    <br>
    <div class="block-card">
      <van-cell title="上传票据" icon="upgrade" @click="showTip = true" is-link />
      <van-cell title="历史上传" icon="photo-o" to="/history" is-link />
      <van-cell title="缴费信息" icon="gold-coin-o" to="/payment" is-link />
      <van-cell title="绑定企业" icon="user-circle-o" to="/bind-user" is-link />
      <van-cell title="企业信息" icon="records" to="/client-info" is-link />
      <van-cell title="发票管理" icon="certificate" to="/invoice/list" is-link />
    </div>
    <change-company :show="showClientList" @change="showClientList = $event" />


  </div>
</template>

<script>
import MyCompany from './commons/my-company'
import ChangeCompany from './commons/change-company'
export default {
  components: { ChangeCompany, MyCompany },
  data() {
    return {
      showClientList: false
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/service.vue